import {
  artworkRequired,
  isArtworkDelivered,
  isLineItemCancelled,
} from '@printdeal/business-logic';

import { SanitizedLineItem } from '../../../../../../types/order/Order';
import { Environment } from '../../../../../../helpers/env';
import LineItem from '../../../../../../types/cart/LineItem';

const ReasonsDisabled = {
  LINE_ITEM_CANCELLED: 'The lineItem has already been cancelled',
  ARTWORK_UNNECESSARY: 'The product does not require artwork',
  ARTWORK_AVAILABLE: 'The required artwork has already been delivered',
};

const canDeliverFilesHelper = (lineItem: SanitizedLineItem | LineItem) => {
  if (isLineItemCancelled(lineItem, Environment)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.LINE_ITEM_CANCELLED,
    };
  }

  if (!artworkRequired(lineItem)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.ARTWORK_UNNECESSARY,
    };
  }

  if (isArtworkDelivered(lineItem)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.ARTWORK_AVAILABLE,
    };
  }

  return {
    enabled: true,
  };
};

export default canDeliverFilesHelper;
